// extracted by mini-css-extract-plugin
export default {"image":"Auth_image__sLclH","paper":"Auth_paper__gO2+u","lock-badge":"Auth_lock-badge__+uLg9"};